import React from "react";
import { Tabs, theme } from 'antd';
import PurchaseListView from "../components/purchase/PurchaseListView";
import PurchasePaidListView from "../components/purchase/PurchasePaidListView";

export default function PurchaseView() {

  const {
    token: { colorPrimary },
  } = theme.useToken();

  const items = [
    {
      key: 'progress',
      label: 'รายการซื้อรอคำนวณเงิน',
      children: <PurchaseListView state={'wait'}/>,
    },
    {
      key: 'all',
      label: 'รายการซื้อทั้งหมด',
      children: <PurchaseListView state={'all'}/>,
    },
    {
      key: 'paid',
      label: 'รายการจ่ายเงิน',
      children: <PurchasePaidListView/>,
    },
  ];

  return(
    <div style={{ marginTop : 20}}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="task" 
        items={items} 
      />
    </div>
  )
}